module.exports = __webpack_public_path__ + "static/img/68081P_C_01_20170813_LC.f28c92f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/68081P_C_01_20170813_LC.png
// module id = Jwme
// module chunks = 0